"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlCheckbox", function ($timeout, keyCodes, uiUtils) {
  var CHECKED_CLASS = "tl-checked",
    FOCUSED_CLASS = "tl-focused";
  return {
    restrict: "E",
    require: "?ngModel",
    transclude: true,
    replace: true,
    template: '' + '<div class="tl-checkbox">' + '<div class="tl-checkbox-container">' + '<div class="tl-checkbox-icon"></div>' + '</div>' + '   <div class="tl-checkbox-label" ng-transclude></div>' + '</div>',
    compile: function compile($el, $attrs) {
      // attach before ng-click to stop propagation when disabled
      $el.on('click', function (event) {
        if (this.hasAttribute('disabled')) {
          event.stopImmediatePropagation();
        }
      });

      // set tabindex to allow focus if unspecified
      if (!$attrs.tabindex) {
        $attrs.$set("tabindex", 0);
      }
      return function postLink($scope, $el, $attrs, ngModelCtrl) {
        if (ngModelCtrl == null) {
          ngModelCtrl = uiUtils.fakeNgModel();
        }
        if ($attrs.ngChecked) {
          $scope.$watch($scope.$eval.bind($scope, $attrs.ngChecked), ngModelCtrl.$setViewValue.bind(ngModelCtrl));
        }
        if ($attrs.checklistValue) {
          checklistLink();
        } else {
          checkboxLink();
        }

        // applying no label class to remove spacing
        var cbxLabel = $el.find(".tl-checkbox-label");
        if (cbxLabel.children().length === 0 && $.trim(cbxLabel.text()) === "") {
          $el.addClass("no-label");
        }

        /**
         * Link for the standard checkbox mecanism
         */
        function checkboxLink() {
          var trueValue = uiUtils.parseConstantExpr($scope, 'ngTrueValue', $attrs.ngTrueValue, true);
          var falseValue = uiUtils.parseConstantExpr($scope, 'ngFalseValue', $attrs.ngFalseValue, false);
          ngModelCtrl.$isEmpty = function (value) {
            return value === false;
          };
          ngModelCtrl.$formatters.push(function (value) {
            return angular.equals(value, trueValue);
          });
          ngModelCtrl.$parsers.push(function (value) {
            return value ? trueValue : falseValue;
          });
          ngModelCtrl.$render = function () {
            if (ngModelCtrl.$viewValue) {
              $el.addClass(CHECKED_CLASS);
            } else {
              $el.removeClass(CHECKED_CLASS);
            }
          };
          function checkboxValueGet() {
            return $attrs.ngChecked ? $attrs.checked : !ngModelCtrl.$viewValue;
          }
          bindEvents(checkboxValueGet);
        }

        /**
         * Link for the checklist mecanism
         */
        function checklistLink() {
          var listboxValue = $scope.$eval($attrs.checklistValue);
          if ($attrs.ngModel) {
            $scope.$watchCollection($attrs.ngModel, function () {
              ngModelCtrl.$render();
            });
          }
          ngModelCtrl.$render = function () {
            if (_.includes(ngModelCtrl.$viewValue, listboxValue)) {
              $el.addClass(CHECKED_CLASS);
            } else {
              $el.removeClass(CHECKED_CLASS);
            }
          };
          function checklistValueGet() {
            var list = ngModelCtrl.$viewValue;
            if (list == null || !_.isArray(list)) {
              list = [];
            }
            var position = _.indexOf(list, listboxValue);
            if (position > -1) {
              list.splice(position, 1);
            } else {
              list.push(listboxValue);
            }
            return list;
          }
          bindEvents(checklistValueGet);
        }
        function bindEvents(viewValueGetter) {
          $scope.mouseActive = false;
          $el.on('click', valueSwitchHandler).on('keypress', function keypressHandler(ev) {
            var keyCode = ev.which || ev.keyCode;
            if (keyCode === keyCodes.SPACE || keyCode === keyCodes.ENTER) {
              ev.preventDefault();
              if (!$el.hasClass(FOCUSED_CLASS)) {
                $el.addClass(FOCUSED_CLASS);
              }
              valueSwitchHandler(ev);
            }
          }).on('mousedown', function () {
            $scope.mouseActive = true;
            $timeout(function () {
              $scope.mouseActive = false;
            }, 100);
          }).on('focus', function () {
            if ($scope.mouseActive === false) {
              $el.addClass(FOCUSED_CLASS);
            }
          }).on('blur', function () {
            $el.removeClass(FOCUSED_CLASS);
          });
          function valueSwitchHandler(ev) {
            if ($el[0].hasAttribute('disabled')) {
              return;
            }
            $scope.$apply(function () {
              // Toggle the checkbox value...
              var viewValue = viewValueGetter();
              ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
              ngModelCtrl.$render();
            });
            $el.trigger("change");
          }
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/inputs/tl-checkbox.js
// module id = 2969
// module chunks = 13